<ix-scheduler
  [formControl]="formControl"
  [hideMinutes]="config.noMinutes"
  [startTime]="startTime"
  [endTime]="endTime"
  [required]="config.required"
  [label]="config.placeholder"
  [tooltip]="config.tooltip"
></ix-scheduler>
